export const getScreenWidth = (): number =>
  typeof window !== 'undefined' ? window.innerWidth : 375;

export const getScreenHeight = (): number =>
  typeof window !== 'undefined' ? window.innerHeight : 667;

export const SCREEN_WIDTH = getScreenWidth();
export const SCREEN_HEIGHT = getScreenHeight();
